import React, { ReactNode } from 'react';

import { MenuManagementSingleSelectInput } from '@/components/templates/PageLayout/Sidebar/MenuManagementsAccordionItem';
import {
  CmBox,
  CmButton,
  CmFlex,
  CmLabelAndInput,
  CmNextLink,
  CmSeparate,
  CmText,
} from '@/components/uiParts';
import { routes } from '@/router';
import { useMenuManagementDownloadBrandItems } from '@/services/BrandItem/hooks/download/useMenuManagementDownloadBrandItems';

type NewPagePath =
  | typeof routes['menuManagementItemsNew']['path']
  | typeof routes['menuManagementMenusNew']['path']
  | typeof routes['menuManagementBusinessHoursNewPage']['path']
  | typeof routes['menuManagementCategoriesNew']['path']
  | typeof routes['menuManagementOptionGroupsNew']['path']
  | typeof routes['menuManagementExecutionsNew']['path'];

type Props = {
  targetInputLabel?:
    | '商品'
    | 'カテゴリ'
    | 'オプショングループ'
    | 'メニュー'
    | 'メニュー提供時間';
  searchCount: number;
  itemValue?: string;
  handleInputTitleJa?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  newPagePath: NewPagePath;
  helpPopover?: ReactNode;
  associateBrandSelectInput?: MenuManagementSingleSelectInput;
  handleClickDownloadCsv?: () => void;
  handleClickUberEatsImportBrandItems?: () => void;
};

export const SEARCH_AREA_ID = 'search-form';

export const MenuManagementSearchArea: React.FC<Props> = ({
  targetInputLabel,
  searchCount,
  itemValue,
  handleInputTitleJa,
  newPagePath,
  helpPopover,
  associateBrandSelectInput,
  handleClickDownloadCsv,
  handleClickUberEatsImportBrandItems,
}): JSX.Element => {
  const { downloadCSV, loading } = useMenuManagementDownloadBrandItems({
    associateBrandId: associateBrandSelectInput?.value?.value || '',
  });
  return (
    <CmFlex
      justifyContent="space-between"
      alignItems="flex-end"
      padding="20px 20px 20px 0"
      id={SEARCH_AREA_ID}
    >
      <CmFlex width="85%" alignItems="flex-end">
        {handleInputTitleJa && (
          <CmBox width="40%">
            <CmLabelAndInput
              bg="white"
              id="name"
              label={`${targetInputLabel}名`}
              fontWeight="bold"
              value={itemValue}
              onChange={handleInputTitleJa}
            />
          </CmBox>
        )}
        <CmBox mx="10px" />
        {helpPopover && helpPopover}
      </CmFlex>
      <CmFlex alignItems="center" pb="5px">
        <CmText minWidth="75px">件数{searchCount}件</CmText>
        {targetInputLabel === '商品' && (
          <>
            <CmSeparate mx="30px" />
            {/*
             // @ts-ignore TS2590 */}
            <CmButton
              disabled={loading}
              onClick={downloadCSV}
              variant="link"
              color="#3182ce"
              fontWeight="300"
            >
              CSVエクスポート
            </CmButton>
          </>
        )}
        {targetInputLabel == '商品' && handleClickDownloadCsv && (
          <>
            <CmSeparate mx="30px" />
            <CmButton
              onClick={handleClickDownloadCsv}
              variant="link"
              color="#3182ce"
              fontWeight="300"
            >
              CSVインポート
            </CmButton>
          </>
        )}
        {targetInputLabel == '商品' && handleClickUberEatsImportBrandItems && (
          <>
            <CmSeparate mx="30px" />
            <CmButton
              onClick={handleClickUberEatsImportBrandItems}
              variant="link"
              color="#3182ce"
              fontWeight="300"
            >
              uber eatsデータインポート
            </CmButton>
          </>
        )}
        <CmSeparate mx="30px" />
        <CmNextLink to={newPagePath}>新規追加</CmNextLink>
      </CmFlex>
    </CmFlex>
  );
};
